import React from "react";
import Pagination from "../common/Pagination";
import TableShowLimit from "../common/TableShowLimit";
import DataNotFound from "../common/DataNotFound";
import RippleLoader from "../RippleLoader/RippleLoader";

const CustomTable = ({
  columnHeaders,
  dataRows,
  data,
  loading,
  paginationCurrentLimit,
  setPaginationCurrentLimit,
  total,
  paginationData,
  showPagination,
  overflowVisibleLg,
  backgroundColor,
  lastPage,
  hasCustomBody = false,
}) => {
  return (
    <div className="w-full">
      {loading ? (
        <RippleLoader />
      ) : (
        <>
          {data?.data?.length || data?.length > 0 ? (
            <div
              className={`rounded-lg overflow-hidden ${
                overflowVisibleLg ? "lg:overflow-visible" : ""
              } ${backgroundColor ? "bg-bgGrey" : "bg-white"}`}
            >
              <table className="w-full text-sm table-fixed border-collapse">
                {/* Table Header */}
                <thead className="text-sm text-primaryBlack bg-navTheme/20 font-normal text-start">
                  <tr>{columnHeaders}</tr>
                </thead>

                {/* Table Body */}
                {!hasCustomBody ? (
                  <tbody className="text-sm font-normal">{dataRows}</tbody>
                ) : (
                  dataRows
                )}
              </table>
            </div>
          ) : (
            <DataNotFound />
          )}

          {/* Pagination */}
          {showPagination && (
            <div className="flex flex-wrap items-center justify-end my-2">
              <TableShowLimit
                paginationCurrentLimit={paginationCurrentLimit}
                setPaginationCurrentLimit={setPaginationCurrentLimit}
                disabled={!data?.data?.length || total <= 10}
              />

              <p
                className={`text-xs font-figtree pl-2 ${
                  !(data?.data?.length > 0) ? "text-grey/60" : "text-black"
                }`}
              >
                {(data?.pagination?.page - 1) * data?.pagination?.limit + 1} -{" "}
                {(data?.pagination?.page - 1) * data?.pagination?.limit +
                  (data?.data?.length || 0)}{" "}
                of {total}
              </p>

              <div className="px-4 py-2 rounded-lg">
                <Pagination
                  total={total}
                  lastPage={lastPage}
                  current={Number(data?.pagination?.page) || 1}
                  pagination={paginationData}
                  disablePrev={!data?.data?.length}
                  disableNext={!data?.data?.length}
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CustomTable;
